<template>
  <div>
    <h1>Te verwerken keuringsrapporten</h1>
    <b-link
     
      :to="{name: 'Verwerkte keuringsrapporten'}"
      class="m-3"
      variant="primary"
    >
      <i class="fa fa-check" /> 
      Klik hier voor de verwerkte rapporten
    </b-link>
    <b-table
      v-if="data.items"
      :items="data.items"
      :fields="[{
                  label: 'Keuringsdatum',
                  key: 'datum',
                },
                'type','instantie','keuringsnummer','resultaat','unit','acties']" 
      selectable
      fixed
      :busy="servicebusy"
      select-mode="single"
      bordered
      hover
      @row-selected="rowSelected"
    >
      <!--- busy template spinning -->
      <template #table-busy>
        <b-spinner
          small
          type="grow"
          variant="primary"
        />
        <span class="ml-2">Laden...</span>
      </template>

      <template #cell()="row">
        {{ row.item[row.field.key].toUpperCase() }}
      </template>

      <template #cell(unit)="row">
        <b-alert
          :show="row.item.unit === 'MULTIPLE'"
          variant="warning"
        >
          Meerdere units gevonden met keuringsnummer {{ row.item.keuringsnummer.toUpperCase() }}
        </b-alert>
        <b-alert
          :show="row.item.unit.id === 'NONE'"
          class="text-black"
          variant="warning"
        >
          GEEN UNIT GEVONDEN!
        </b-alert>
        <div v-if="row.item.unit.id !== 'NONE'">
          <b-link
            :to="{name:'Algemeen',params:{id:row.item.unit.id}}"
          >
            {{ row.item.unit.info[0] }}
          </b-link>
          {{ row.item.unit.info[1] }}, {{ row.item.unit.info[2] }}, {{ row.item.unit.info[3] }}
        </div>
      </template>

      <template #cell(acties)="row">
        <!-- <b-button
          size="sm"
          variant="primary"
          @click="selected_pdf = row.item.pdf"
        >
          Download
        </b-button> -->
        <b-link :to="{name: 'Keuringsrapport', params:{id:row.item.id}}">
          VERWERKEN
        </b-link>
      </template>
    </b-table>
    
    <b-button
      v-if="data.cursor"
      :disabled="loading_more"
      block
      variant="outline-secondary"
      class="my-3"
      size="lg"
      @click="addReports()"
    >
      <i
        v-if="loading_more"
        class="fa fa-spinner"
      />
      
      Meer laden
    </b-button>
  </div>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";

export default {
  name: "KeuringenQueue",
  mixins: [serviceMixin],
  data() {
    return {
      data: {
        cursor: null,
        items: []
      },
      loading_more: false,
    };
  },
  computed: {
    path() {
      return this.$route.path;
    }
  },
  mounted() {
    this.getReports();
  },
  methods: {
    rowSelected(item) {
      if (item.length == 1) {
        this.$router.push({ name: 'Keuringsrapport', params: { id: item[0].id } });
      }
      // goto route 
      },
    downloadrapport() {
      
    },
    getReports() {
      this.get(this.path).then((response) => {
        this.data = response.data;
        console.dir(response.data);
      });
    },
    addReports() {
      this.loading_more = true;
      this.post(this.path, { ...this.data.cursor, offset: this.data.items.length }).then((response) => {
        this.data.items = this.data.items.concat(response.data.items);
        this.data.cursor = response.data.cursor;
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        this.loading_more = false;
      });
    },
  },
};
</script>